import * as React from "react"
import {TextFieldSeeker} from "@ui-seeker/core";
import {useMatchersSkusForm} from "../../@hooks";


export default function MatchersSKUsDrawerEan() {
	const { localValue, handleChange } = useMatchersSkusForm('ean')

    return <TextFieldSeeker
		fullWidth
		label="EAN"
		placeholder="Please enter the EAN"
		value={localValue || ''}
		onChange={e => handleChange(e.target.value)}
	/>
}
